import { cn } from "@/lib/utils";

/** Small status chip used across Inventory & Requirements cards. */
export function StatusChip({ status, className }) {
  const map = {
    Active: "border-[#35622F]/30 text-[#35622F] bg-[#35622F]/5",
    Archived: "border-gray-200 text-gray-500 bg-gray-50",
    Closed: "border-gray-200 text-gray-500 bg-gray-50",
    Disputed: "border-amber-300 text-amber-700 bg-amber-50",
  };
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold",
        map[status] || "border-gray-200 text-gray-500 bg-gray-50",
        className
      )}
      data-testid={`status-chip-${String(status).toLowerCase()}`}
    >
      {status}
    </span>
  );
}

export function ExclusiveAtsChip({ className }) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 rounded-full border border-[#35622F]/25 bg-[#35622F]/10 px-2.5 py-0.5 text-xs font-semibold text-[#35622F]",
        className
      )}
      data-testid="exclusive-ats-chip"
    >
      <span className="h-1.5 w-1.5 rounded-full bg-[#35622F]" />
      Exclusive ATS
    </span>
  );
}
